import Grid from '@material-ui/core/Grid';
import { Button, TextField } from '@material-ui/core';
import LoadingSpinner from '../loading-spinner';
import React from 'react';
import { FormikProps } from 'formik';
import { TReportCreate } from '../../../definitions';
import { createReportStyles } from './styles';
import SelectUsers from './select-users';
import { useHistory } from 'react-router-dom';

export default function ReportForm(props: FormikProps<TReportCreate>) {
  const classes = createReportStyles();
  const history = useHistory();

  const {
    values,
    errors,
    touched,
    handleSubmit,
    handleChange,
    handleBlur,
    isSubmitting,
    setFieldValue
  } = props;

  const formikProps = (name: string, initialValue = '') => ({
    name: name,
    value: typeof values[name] !== 'undefined' ? values[name] : initialValue,
    onChange: handleChange,
    onBlur: handleBlur,
    error: touched[name] && Boolean(errors[name]),
    helperText: touched[name] ? errors[name] : ''
  });
  console.debug('ReportForm', values);
  return (
    <form noValidate autoComplete="off" onSubmit={handleSubmit}>
      <Grid container spacing={2} direction="column">
        <Grid item>
          <TextField
            {...formikProps('name')}
            label="Report Name"
            type="text"
            variant="outlined"
            fullWidth={true}
          />
        </Grid>

        <Grid item>
          <TextField
            {...formikProps('link')}
            label="Report URL"
            type="text"
            variant="outlined"
            fullWidth={true}
          />
        </Grid>
      </Grid>
      <Grid item>
        <SelectUsers onSelect={(users) => setFieldValue('users', users)} />
      </Grid>
      <Grid container justify="flex-end" spacing={2}>
        <>
          <Grid item>
            <Button
              className={classes.margin}
              type="submit"
              variant="contained"
              size="large"
              fullWidth
              color="primary"
              disabled={isSubmitting}
            >
              {isSubmitting && <LoadingSpinner />}
              Create
            </Button>
          </Grid>

          <Grid item>
            <Button
              className={classes.margin}
              variant="outlined"
              size="large"
              color="secondary"
              fullWidth
              onClick={() => history.goBack()}
              disabled={isSubmitting}
            >
              Cancel
            </Button>
          </Grid>
        </>

        {/*{error && (*/}
        {/*  <div>*/}
        {/*    <span className={classes.errorText}>{error.message}</span>*/}
        {/*  </div>*/}
        {/*)}*/}
      </Grid>
    </form>
  );
}
